import { useCallback } from 'react';
import { IS_B_ANALYTICS_TOOL_ENABLED } from 'src/config';
import { usePostHog } from '@posthog/react';
import { StringKeys } from 'src/types/base';
import { getSubdomain } from 'src/utils/analyticsUtils';
import { RootState, useSelector } from 'src/redux/store';
const tenantName = getSubdomain();

const useAnalytics = () => {
  const posthog = usePostHog();
  const { subscriptionInfo, analyticsSalt } = useSelector(
    (state: RootState) => state.library
  );

  const collectAnalytics = (eventName, eventDetails: StringKeys = {}) => {
    if (IS_B_ANALYTICS_TOOL_ENABLED) {
      if (analyticsSalt) {
        eventDetails['distinct_id'] = analyticsSalt;
      }
      try {
        posthog?.capture(eventName, {
          subscription_status:
            subscriptionInfo?.tier_name?.toLowerCase() || 'custom',
          billing_period:
            subscriptionInfo?.billing_period?.toLowerCase() || 'custom',
          ...eventDetails,
          tenant_name: tenantName
        });
      } catch (error) {
        // Posthog doesn't exist!
        console.error(error);
      }
    }
  };

  return collectAnalytics;
};

export default useAnalytics;
